import  axios  from "../api/axios";
import { memoizedRefreshToken } from "./RefreshToken";

//axios.defaults.baseURL = "http://localhost:3333/api";

axios.interceptors.request.use(
    async (config) => {
        const session = JSON.parse(localStorage.getItem("crmSite"));

        if(session?.access){
            config.headers = {
                ...config.headers,
                Authorization: `${session?.access}`,
            };
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config =  error?.config;

        if(error?.response?.status === 401 && !config?.sent){
            config.sent = true;

            const result = await memoizedRefreshToken();

            if( result?.access){
                config.headers = {
                    ...config.headers,
                    Authorization: `${result?.access}`,
                };
            }
            return axios(config);
        }
        return Promise.reject(error);
    }
);

export const axiosPrivate= axios;